import {
    bookingSlotList,
    bookingSlotTime
} from "./constants";
import type {
    GabBooking,
    GabBookingRaw,
    GabHeader,
    GabHeaderRaw
} from "../models/GabModule";

/**
 * @param isoString
 */
export function translateStringDate(isoString: string){
    return new Date(new Date(isoString).toString());
}

/**
 *
 * @param date
 */
export function formatDateToDateString(date: Date) {
    return date.toLocaleString([], { month: "2-digit", day: "2-digit" });
}

/**
 *
 * @param date
 */
export function formatDateToTimeString(date: Date) {
    return date.toLocaleString([], { hour: "2-digit", minute: "2-digit" });
}

/**
 * Get slot number, 0 = full
 * needed to calculate slot time (15 min * n.slot)
 * @param requestId
 * @param booking
 */
export function getBookingSlotNumber(requestId: number | null = null, booking: GabBooking){
    if(booking.slot1 === requestId)
        return 1;
    else if(booking.slot2 === requestId)
        return 2;
    else if(booking.slot3 === requestId)
        return 3;
    else if(booking.slot4 === requestId)
        return 4;
    return 0;
}

/**
 * Translate server GabBookingRaw data in local enhanced GabBooking
 * @param item
 */
export function translateRawGabBooking(item: GabBookingRaw): GabBooking {
    const booking_date = new Date(translateStringDate(item.book_date));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const booking: any = {
        ...item,
        book_date: booking_date.toISOString(),
        book_date_date: booking_date,
        time_text: formatDateToTimeString(booking_date),
        date_text: formatDateToDateString(booking_date),
    };
    for(let s = bookingSlotList.length; s--; ) {
        // it doesn't exist OR if it's not an object
        if (!Object.prototype.hasOwnProperty.call(item, bookingSlotList[s]) || !item[bookingSlotList[s]] || typeof item[bookingSlotList[s]] !== 'object')
            continue;
        booking[bookingSlotList[s]] = (item[bookingSlotList[s]] as GabHeader).request_id || null;
    }
    return booking
}

/**
 *
 * @param item
 * @param booking
 */
export function translateRawGabHeader(item: GabHeaderRaw, booking: GabBooking): GabHeader {
    const slot = getBookingSlotNumber(item.request_id, booking);
    return {
        ...item,
        book_id: booking.book_id,
        date: new Date(new Date(booking.book_date).getTime() + (slot - 1) * bookingSlotTime)
    }
}

/**
 * Normalize and dissect the complex object from the server
 * and return the separated (but still linked through id) items
 * @param item
 */
export function translateRawGabData(item: GabBookingRaw): [GabBooking, GabHeader[]] {
    const booking = translateRawGabBooking(item);
    const headers: GabHeader[] = [];
    for(let s = bookingSlotList.length; s--; ){
        if(!Object.prototype.hasOwnProperty.call(item, bookingSlotList[s]) || !item[bookingSlotList[s]])
            continue;
        if((item[bookingSlotList[s]] as GabHeader).request_id && (item[bookingSlotList[s]] as GabHeader).request_id !== -1)
            headers.push(translateRawGabHeader(item[bookingSlotList[s]] as GabHeader, booking))
    }
    return [
        booking,
        headers,
    ]
}
